import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Divider,
  Grid,
  Chip,
  Avatar,
  CircularProgress,
  Paper,
  IconButton,
  Tooltip,
  useTheme,
  Alert,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Menu,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Snackbar,
  Badge,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Switch,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import {
  Search,
  FilterList,
  Refresh,
  Delete,
  Edit,
  Visibility,
  MoreVert,
  CloudDownload,
  PersonAddDisabled,
  ShoppingCart,
  Favorite,
  LocationOn,
  Phone,
  Email,
  VerifiedUser,
  GppBad,
  CheckCircle,
  Cancel,
  SaveAlt,
  Close,
  PersonAdd,
  FileDownload
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { saveAs } from "file-saver";
import pb from "./pocketbase"; // PocketBase client
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

// Styled components
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 500,
  borderBottom: `1px solid ${theme.palette.divider}`,
  "&.MuiTableCell-head": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[50],
    color: theme.palette.text.secondary,
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.grey[50],
  },
  "&:hover": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
    cursor: "pointer",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// Function to export data to CSV
const exportToCSV = (data, filename) => {
  if (!data || !data.length) return;
  
  // Extract column headers from first item
  const headers = Object.keys(data[0]);
  
  // Create CSV rows
  const csvRows = [
    // Header row
    headers.join(','),
    // Data rows
    ...data.map(row => 
      headers.map(header => {
        const cell = row[header];
        // Quote strings with commas and handle undefined/null
        if (cell === null || cell === undefined) return '';
        if (typeof cell === 'string' && (cell.includes(',') || cell.includes('"') || cell.includes('\n'))) {
          return `"${cell.replace(/"/g, '""')}"`;
        }
        return cell;
      }).join(',')
    )
  ].join('\n');
  
  // Create download link
  const blob = new Blob([csvRows], { type: 'text/csv;charset=utf-8;' });
  saveAs(blob, `${filename}_${new Date().toISOString().split('T')[0]}.csv`);
};

const CustomersPage = () => {
  // Current admin info
  const currentDate = "2025-04-02";
  const currentDateTime = "2025-04-02 06:04:27";
  const currentUser = "MdAbuNafisNiloy";

  // State
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const [filterMenuAnchorEl, setFilterMenuAnchorEl] = useState(null);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState(null);
  const [currentCustomerId, setCurrentCustomerId] = useState(null);
  const [filters, setFilters] = useState({
    status: "all", // all, verified, unverified
    sortBy: "created_desc" // created_desc, created_asc, name_asc, name_desc
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAllCustomers, setSelectAllCustomers] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info"
  });
  const [editForm, setEditForm] = useState({
    username: "",
    name: "",
    email: "",
    phone: "",
    street: "",
    city: "",
    village: "",
    country: "",
    postalCode: "",
    verified: false,
    emailVisibility: true
  });

  const navigate = useNavigate();
  const theme = useTheme();

  // Fetch customers on component mount and when filters/pagination change
  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        setLoading(true);
        
        // Build filter string for PocketBase
        let filterStr = '';
        
        // Status filter
        if (filters.status === "verified") {
          filterStr = 'verified = true';
        } else if (filters.status === "unverified") {
          filterStr = 'verified = false';
        }
        
        // Search query filter
        if (searchQuery) {
          const searchFilter = `(username~"${searchQuery}" || name~"${searchQuery}" || email~"${searchQuery}" || phone~"${searchQuery}")`;
          filterStr = filterStr ? `${filterStr} && ${searchFilter}` : searchFilter;
        }
        
        // Sort options
        let sortStr;
        switch (filters.sortBy) {
          case "created_asc":
            sortStr = "created";
            break;
          case "name_asc":
            sortStr = "name";
            break;
          case "name_desc":
            sortStr = "-name";
            break;
          case "created_desc":
          default:
            sortStr = "-created";
        }
        
        // Fetch customers from PocketBase
        const customersData = await pb.collection("users").getList(page + 1, rowsPerPage, {
          filter: filterStr,
          sort: sortStr
        });

        

        
        setCustomers(customersData.items);
        setTotalCustomers(customersData.totalItems);
        setError(null);



      } catch (err) {
        console.error("Error fetching customers:", err);
        setError("Failed to load customers. Please try again later.");
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    };
    
    fetchCustomers();
  }, [page, rowsPerPage, filters, searchQuery, refreshing]);

  // Handle refresh
  const handleRefresh = () => {
    setRefreshing(true);
  };

  // Handle search
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  // Handle filter menu
  const handleFilterMenuOpen = (event) => {
    setFilterMenuAnchorEl(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchorEl(null);
  };

  // Handle filter changes
  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
    setPage(0);
    handleFilterMenuClose();
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Handle row click to view customer details
  const handleRowClick = (customer) => {
    setSelectedCustomer(customer);
    setViewDialogOpen(true);
    console.log("Customer details:", parseJSON(customer.cart).length, parseJSON(customer.wishlist));
  };

  // Handle action menu
  const handleActionMenuOpen = (event, customerId) => {
    event.stopPropagation();
    setActionMenuAnchorEl(event.currentTarget);
    setCurrentCustomerId(customerId);
  };

  const handleActionMenuClose = () => {
    setActionMenuAnchorEl(null);
    setCurrentCustomerId(null);
  };

  // Handle edit click
  const handleEditClick = (event, customer) => {
    event.stopPropagation();
    setSelectedCustomer(customer);
    setEditForm({
      username: customer.username || "",
      name: customer.name || "",
      email: customer.email || "",
      phone: customer.phone || "",
      street: customer.street || "",
      city: customer.city || "",
      village: customer.village || "",
      country: customer.country || "",
      postalCode: customer.postalCode || "",
      verified: customer.verified || false,
      emailVisibility: customer.emailVisibility || true
    });
    setEditDialogOpen(true);
  };

  // Handle delete click
  const handleDeleteClick = (event, customer) => {
    event.stopPropagation();
    setSelectedCustomer(customer);
    setDeleteDialogOpen(true);
  };

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: name === "verified" || name === "emailVisibility" ? checked : value
    }));
  };

  // Handle toggle verification
  const handleToggleVerification = async (customerId, currentStatus) => {
    console.log(!currentStatus);
    try {
      // Make sure verified is explicitly a boolean value
      const newVerificationStatus = currentStatus === true ? false : true;
      
      // Update the customer verification status in PocketBase
      await pb.collection("users").update(customerId, {
        "verified": newVerificationStatus
      });
      
      // Update the local state
      setCustomers(customers.map(customer => 
        customer.id === customerId 
          ? { ...customer, verified: !currentStatus } 
          : customer
      ));
      
      setSnackbar({
        open: true,
        message: currentStatus 
          ? "Customer verification revoked" 
          : "Customer verified successfully",
        severity: "success"
      });
      
      // If the detail view is open, update that too
      if (selectedCustomer && selectedCustomer.id === customerId) {
        setSelectedCustomer({
          ...selectedCustomer,
          verified: !currentStatus
        });
      }
      
      handleActionMenuClose();
    } catch (error) {
      console.error("Error updating customer verification:", error);
      console.error("Error details:", error.response?.data || error.message);
      setSnackbar({
        open: true,
        message: "Failed to update customer verification status",
        severity: "error"
      });
    }
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      setLoading(true);
      
      // Update the customer in PocketBase
      const updatedCustomer = await pb.collection("users").update(selectedCustomer.id, {
        ...editForm
      });
      
      // Update the customers list
      setCustomers(customers.map(customer => 
        customer.id === selectedCustomer.id 
          ? updatedCustomer 
          : customer
      ));
      
      // Update selected customer if details view is open
      if (viewDialogOpen) {
        setSelectedCustomer(updatedCustomer);
      }
      
      setSnackbar({
        open: true,
        message: "Customer information updated successfully",
        severity: "success"
      });
      
      setEditDialogOpen(false);
    } catch (error) {
      console.error("Error updating customer:", error);
      setSnackbar({
        open: true,
        message: "Failed to update customer information",
        severity: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle delete customer
  const handleDeleteCustomer = async () => {
    try {
      setLoading(true);
      
      // Delete the customer from PocketBase
      await pb.collection("users").delete(selectedCustomer.id);
      
      // Update the customers list
      setCustomers(customers.filter(customer => customer.id !== selectedCustomer.id));
      
      setSnackbar({
        open: true,
        message: "Customer deleted successfully",
        severity: "success"
      });
      
      setDeleteDialogOpen(false);
      setViewDialogOpen(false);
    } catch (error) {
      console.error("Error deleting customer:", error);
      setSnackbar({
        open: true,
        message: "Failed to delete customer",
        severity: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  // Export functionality
  const handleExportDialogOpen = () => {
    setExportDialogOpen(true);
  };

  const handleExportDialogClose = () => {
    setExportDialogOpen(false);
  };

  const toggleSelectAllCustomers = () => {
    setSelectAllCustomers(prevState => {
      const newSelectAllState = !prevState;
      // Use the new state value directly here
      setSelectedRows(newSelectAllState ? customers.map((_, index) => index) : []);
      return newSelectAllState;
    });
  };
  const toggleSelectCustomer = (index) => {
    setSelectedRows(prevSelected => {
      if (prevSelected.includes(index)) {
        return prevSelected.filter(idx => idx !== index);
      } else {
        return [...prevSelected, index];
      }
    });
  };

  const prepareExportData = () => {
    // Filter customers based on selectedRows if not selectAllCustomers
    const customersToExport = selectAllCustomers ? customers : customers.filter((_, index) => selectedRows.includes(index));
    
    // Map customers to export format with safer JSON parsing
    return customersToExport.map(customer => {
      // Safely parse cart data
      let cartItems = 0;
      try {
        if (customer.cart) {
          if (typeof customer.cart === "string") {
            if (customer.cart !== "JSON" && customer.cart.trim() !== "") {
              const parsedCart = JSON.parse(customer.cart);
              cartItems = Array.isArray(parsedCart) ? parsedCart.length : 0;
            }
          } else if (Array.isArray(customer.cart)) {
            cartItems = customer.cart.length;
          }
        }
      } catch (error) {
        console.error("Error parsing cart JSON:", error);
        cartItems = 0;
      }
  
      // Safely parse wishlist data
      let wishlistItems = 0;
      try {
        if (customer.wishlist) {
          if (typeof customer.wishlist === "string") {
            if (customer.wishlist !== "JSON" && customer.wishlist.trim() !== "") {
              const parsedWishlist = JSON.parse(customer.wishlist);
              wishlistItems = Array.isArray(parsedWishlist) ? parsedWishlist.length : 0;
            }
          } else if (Array.isArray(customer.wishlist)) {
            wishlistItems = customer.wishlist.length;
          }
        }
      } catch (error) {
        console.error("Error parsing wishlist JSON:", error);
        wishlistItems = 0;
      }
  
      // Return customer data with safely parsed values
      return {
        ID: customer.id,
        Username: customer.username || "",
        Name: customer.name || "",
        Email: customer.email || "",
        Phone: customer.phone || "",
        Address: `${customer.street || ""}, ${customer.city || ""}, ${customer.postalCode || ""}`,
        Country: customer.country || "",
        Verified: customer.verified ? "Yes" : "No",
        Created: format(new Date(customer.created), "yyyy-MM-dd"),
        Updated: format(new Date(customer.updated), "yyyy-MM-dd"),
        Cart_Items: cartItems,
        Wishlist_Items: wishlistItems
      };
    });
  };

  const handleExport = () => {
    setExportLoading(true);
    
    setTimeout(() => {
      try {
        const exportData = prepareExportData();
        exportToCSV(exportData, "customers_report");
        
        setSnackbar({
          open: true,
          message: "Customers data exported successfully as CSV",
          severity: "success"
        });
        
        handleExportDialogClose();
      } catch (error) {
        console.error("Error exporting data:", error);
        setSnackbar({
          open: true,
          message: `Failed to export customers data: ${error.message}`,
          severity: "error"
        });
      } finally {
        setExportLoading(false);
      }
    }, 1000);
  };

  // Format date and time
  const formatDateTime = (dateTimeString) => {
    try {
      return format(new Date(dateTimeString), "MMM d, yyyy • h:mm a");
    } catch (error) {
      return dateTimeString;
    }
  };

  // Get avatar URL
  const getAvatarUrl = (customer) => {
    if (customer.avatar && customer.avatar !== "filename.jpg") {
      return pb.files.getUrl(customer, customer.avatar);
    }
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(customer.name || customer.username || "User")}&background=random`;
  };

  // Parse JSON data from cart and wishlist
  const parseJSON = (jsonStr) => {
    if (!jsonStr || jsonStr === "JSON") return [];
    try {
      let data;
      if (typeof jsonStr === 'string') {
        data = JSON.parse(jsonStr);
      } else {
        data = jsonStr;
      }
      
      // Handle both array and object structures
      if (Array.isArray(data)) {
        return data;
      } else if (typeof data === 'object') {
        return Object.values(data); // Convert object to array of values
      }
      return [];
    } catch (e) {
      console.error("Error parsing JSON:", e);
      return [];
    }
  };

  return (
    <Box sx={{ p: 3, bgcolor: "#f8fafc", minHeight: "100vh" }}>
      {/* Header */}
      <Box sx={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: { xs: "flex-start", md: "center" }, 
        flexDirection: { xs: "column", md: "row" }, 
        mb: 4,
        gap: 2
      }}>
        <Box>
          <Typography variant="h4" fontWeight={700} sx={{ mb: 0.5 }}>
            Customers Management
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage all customers, view their details and activity
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Tooltip title="Refresh Customers">
            <IconButton 
              color="primary" 
              onClick={handleRefresh}
              disabled={refreshing}
              sx={{ 
                bgcolor: "#fff", 
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 2
              }}
            >
              {refreshing ? <CircularProgress size={24} /> : <Refresh />}
            </IconButton>
          </Tooltip>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CloudDownload />}
            onClick={handleExportDialogOpen}
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            Export Customers
          </Button>
        </Box>
      </Box>

      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} sx={{ borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Total Customers
                </Typography>
                <Avatar sx={{ bgcolor: theme.palette.primary.main, width: 48, height: 48 }}>
                  <PersonAdd />
                </Avatar>
              </Box>
              <Typography variant="h4" fontWeight={700}>
                {totalCustomers}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Registered users
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} sx={{ borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Verified Users
                </Typography>
                <Avatar sx={{ bgcolor: theme.palette.success.main, width: 48, height: 48 }}>
                  <VerifiedUser />
                </Avatar>
              </Box>
              <Typography variant="h4" fontWeight={700}>
                {customers.filter(c => c.verified).length}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Email verified users
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} sx={{ borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Unverified Users
                </Typography>
                <Avatar sx={{ bgcolor: theme.palette.warning.main, width: 48, height: 48 }}>
                  <GppBad />
                </Avatar>
              </Box>
              <Typography variant="h4" fontWeight={700}>
                {customers.filter(c => !c.verified).length}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Pending verification
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={0} sx={{ borderRadius: 3, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)" }}>
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Recent Customers
                </Typography>
                <Avatar sx={{ bgcolor: theme.palette.info.main, width: 48, height: 48 }}>
                  <PersonAdd />
                </Avatar>
              </Box>
              <Typography variant="h4" fontWeight={700}>
                {customers.filter(c => {
                  const thirtyDaysAgo = new Date();
                  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                  return new Date(c.created) > thirtyDaysAgo;
                }).length}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                In the last 30 days
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Filters and search */}
      <Paper sx={{ mb: 3, p: 2, borderRadius: 2, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)" }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={7}>
            <TextField
              fullWidth
              placeholder="Search by name, username, email or phone..."
              variant="outlined"
              value={searchQuery}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search color="action" />
                  </InputAdornment>
                ),
              }}
              size="small"
              sx={{ bgcolor: "#fff" }}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <Box sx={{ display: "flex", gap: 1, justifyContent: { xs: "flex-start", md: "flex-end" } }}>
              <Button
                variant="outlined"
                startIcon={<FilterList />}
                onClick={handleFilterMenuOpen}
                size="small"
                sx={{ textTransform: "none" }}
              >
                Filter
              </Button>
              <Button
                variant="outlined"
                startIcon={<Refresh />}
                onClick={() => {
                  setSearchQuery("");
                  setFilters({ status: "all", sortBy: "created_desc" });
                  handleRefresh();
                }}
                size="small"
                sx={{ textTransform: "none" }}
              >
                Reset
              </Button>
              <Button
                variant="outlined"
                startIcon={<CloudDownload />}
                onClick={handleExportDialogOpen}
                size="small"
                sx={{ textTransform: "none" }}
              >
                Export
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Filter Menu */}
      <Menu
        anchorEl={filterMenuAnchorEl}
        open={Boolean(filterMenuAnchorEl)}
        onClose={handleFilterMenuClose}
        PaperProps={{
          elevation: 2,
          sx: { width: 240, maxWidth: "100%", borderRadius: 2 }
        }}
      >
        <MenuItem disabled>
          <Typography variant="subtitle2" fontWeight={600}>
            Filter by Status
          </Typography>
        </MenuItem>
        <MenuItem 
          selected={filters.status === "all"} 
          onClick={() => handleFilterChange("status", "all")}
        >
          All Customers
        </MenuItem>
        <MenuItem 
          selected={filters.status === "verified"} 
          onClick={() => handleFilterChange("status", "verified")}
        >
          Verified Users
        </MenuItem>
        <MenuItem 
          selected={filters.status === "unverified"} 
          onClick={() => handleFilterChange("status", "unverified")}
        >
          Unverified Users
        </MenuItem>
        <Divider />
        <MenuItem disabled>
          <Typography variant="subtitle2" fontWeight={600}>
            Sort By
          </Typography>
        </MenuItem>
        <MenuItem 
          selected={filters.sortBy === "created_desc"} 
          onClick={() => handleFilterChange("sortBy", "created_desc")}
        >
          Newest First
        </MenuItem>
        <MenuItem 
          selected={filters.sortBy === "created_asc"} 
          onClick={() => handleFilterChange("sortBy", "created_asc")}
        >
          Oldest First
        </MenuItem>
        <MenuItem 
          selected={filters.sortBy === "name_asc"} 
          onClick={() => handleFilterChange("sortBy", "name_asc")}
        >
          Name (A to Z)
        </MenuItem>
        <MenuItem 
          selected={filters.sortBy === "name_desc"} 
          onClick={() => handleFilterChange("sortBy", "name_desc")}
        >
          Name (Z to A)
        </MenuItem>
      </Menu>

      {/* Customers Table */}
      {error ? (
        <Alert 
          severity="error" 
          sx={{ mt: 2 }}
          action={
            <Button color="inherit" size="small" onClick={handleRefresh}>
              Retry
            </Button>
          }
        >
          {error}
        </Alert>
      ) : (
        <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: 2, boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ width: 50 }}>
                    <Checkbox
                      checked={selectAllCustomers}
                      onChange={toggleSelectAllCustomers}
                      color="primary"
                    />
                  </StyledTableCell>
                  <StyledTableCell>Customer</StyledTableCell>
                  <StyledTableCell>Contact</StyledTableCell>
                  <StyledTableCell>Location</StyledTableCell>
                  <StyledTableCell align="center">Status</StyledTableCell>
                  <StyledTableCell align="center">Cart Items</StyledTableCell>
                  <StyledTableCell align="center">Wishlist</StyledTableCell>
                  <StyledTableCell align="right">Joined</StyledTableCell>
                  <StyledTableCell align="center">Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 5 }}>
                      <CircularProgress size={40} />
                      <Typography variant="body2" sx={{ mt: 2 }}>
                        Loading customers data...
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : customers.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 5 }}>
                      <Typography variant="body1">
                        No customers found
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Try adjusting your search or filter to find what you're looking for
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  customers.map((customer, index) => {
                    const cart = parseJSON(customer.cart);
                    const wishlist = parseJSON(customer.wishlist);
                    
                    return (
                      <StyledTableRow 
                        key={customer.id}
                        onClick={() => handleRowClick(customer)}
                      >
                        <TableCell onClick={(e) => e.stopPropagation()}>
                          <Checkbox
                            checked={selectedRows.includes(index)}
                            onChange={() => toggleSelectCustomer(index)}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            <Avatar 
                              src={getAvatarUrl(customer)} 
                              alt={customer.name || customer.username}
                              sx={{ width: 40, height: 40 }}
                            />
                            <Box>
                              <Typography variant="body2" fontWeight={500}>
                                {customer.name || "No Name"}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                @{customer.username}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Email fontSize="small" color="action" /> {customer.email}
                          </Typography>
                          {customer.phone && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <Phone fontSize="small" color="action" /> {customer.phone}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell>
                          {(customer.city || customer.country) ? (
                            <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                              <LocationOn fontSize="small" color="action" />
                              {customer.city || ''}{customer.city && customer.country ? ', ' : ''}{customer.country || ''}
                            </Typography>
                          ) : (
                            <Typography variant="caption" color="text.secondary">
                              No location information
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            size="small"
                            color={customer.verified ? "success" : "warning"}
                            icon={customer.verified ? <CheckCircle /> : <Cancel />}
                            label={customer.verified ? "Verified" : "Unverified"}
                            sx={{ fontWeight: 500 }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Badge badgeContent={cart.length} color="primary" showZero>
                            <ShoppingCart color="action" />
                          </Badge>
                        </TableCell>
                        <TableCell align="center">
                          <Badge badgeContent={wishlist.length} color="secondary" showZero>
                            <Favorite color="action" />
                          </Badge>
                        </TableCell>
                        <TableCell align="right">
                          <Typography variant="body2">
                            {format(new Date(customer.created), "MMM d, yyyy")}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <Tooltip title="View Details">
                              <IconButton 
                                size="small" 
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRowClick(customer);
                                }}
                              >
                                <Visibility fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit Customer">
                              <IconButton 
                                size="small" 
                                onClick={(e) => handleEditClick(e, customer)}
                              >
                                <Edit fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="More Actions">
                              <IconButton 
                                size="small" 
                                onClick={(e) => handleActionMenuOpen(e, customer.id)}
                              >
                                <MoreVert fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </StyledTableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
          
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={totalCustomers}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}

      {/* Action Menu */}
      <Menu
        anchorEl={actionMenuAnchorEl}
        open={Boolean(actionMenuAnchorEl)}
        onClose={handleActionMenuClose}
        PaperProps={{
          elevation: 2,
          sx: { width: 200, borderRadius: 2 }
        }}
      >
        {currentCustomerId && (
          <>
            <MenuItem onClick={() => {
              const customer = customers.find(c => c.id === currentCustomerId);
              handleToggleVerification(currentCustomerId, customer.verified);
            }}>
              {customers.find(c => c.id === currentCustomerId)?.verified ? (
                <>
                  <Cancel fontSize="small" color="error" sx={{ mr: 1 }} />
                  <Typography variant="body2">Revoke Verification</Typography>
                </>
              ) : (
                <>
                  <CheckCircle fontSize="small" color="success" sx={{ mr: 1 }} />
                  <Typography variant="body2">Verify User</Typography>
                </>
              )}
            </MenuItem>
            <Divider />
            <MenuItem onClick={() => {
              const customer = customers.find(c => c.id === currentCustomerId);
              handleDeleteClick({ stopPropagation: () => {} }, customer);
              handleActionMenuClose();
            }}>
              <Delete fontSize="small" color="error" sx={{ mr: 1 }} />
              <Typography variant="body2">Delete User</Typography>
            </MenuItem>
          </>
        )}
      </Menu>

     {/* View Customer Dialog */}
<Dialog
  open={viewDialogOpen}
  onClose={() => setViewDialogOpen(false)}
  fullWidth
  maxWidth="md"
  PaperProps={{
    sx: { borderRadius: 2 }
  }}
>
  {selectedCustomer && (
    <>
      <DialogTitle>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6" fontWeight={600}>
            Customer Details
          </Typography>
          <Box>
            <Tooltip title="Edit Customer">
              <IconButton
                edge="end"
                onClick={() => {
                  setViewDialogOpen(false);
                  handleEditClick({ stopPropagation: () => {} }, selectedCustomer);
                }}
              >
                <Edit />
              </IconButton>
            </Tooltip>
            <IconButton
              edge="end"
              onClick={() => setViewDialogOpen(false)}
            >
              <Close />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Profile" />
        <Tab label="Address" />
      </Tabs>
      
      <DialogContent dividers>
        {/* Profile Tab */}
        {tabValue === 0 && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box sx={{ 
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center", 
                textAlign: "center",
                mb: 3
              }}>
                <Avatar
                  src={getAvatarUrl(selectedCustomer)}
                  sx={{ 
                    width: 120, 
                    height: 120, 
                    mb: 2,
                    boxShadow: 3,
                  }}
                />
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {selectedCustomer.name || "No Name"}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  @{selectedCustomer.username}
                </Typography>
                <Chip
                  label={selectedCustomer.verified ? "Verified User" : "Unverified User"}
                  color={selectedCustomer.verified ? "success" : "warning"}
                  size="small"
                  icon={selectedCustomer.verified ? <CheckCircle fontSize="small" /> : <Cancel fontSize="small" />}
                />
              </Box>
              
              <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                  Account Information
                </Typography>
                
                <Box sx={{ mb: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    User ID
                  </Typography>
                  <Typography variant="body2">
                    {selectedCustomer.id}
                  </Typography>
                </Box>
                
                <Box sx={{ mb: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    Joined
                  </Typography>
                  <Typography variant="body2">
                    {formatDateTime(selectedCustomer.created)}
                  </Typography>
                </Box>
                
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    Last Updated
                  </Typography>
                  <Typography variant="body2">
                    {formatDateTime(selectedCustomer.updated)}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
            
            <Grid item xs={12} md={8}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Contact Information
                </Typography>
                
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">
                        Email Address
                      </Typography>
                      <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Email fontSize="small" color="action" />
                        {selectedCustomer.email}
                        {!selectedCustomer.emailVisibility && (
                          <Chip size="small" label="Private" color="default" variant="outlined" sx={{ ml: 1 }} />
                        )}
                      </Typography>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">
                        Phone Number
                      </Typography>
                      <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Phone fontSize="small" color="action" />
                        {selectedCustomer.phone || "Not provided"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Box>
              
              <Box>
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  Additional Information
                </Typography>
                
                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">
                        Account Status
                      </Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5, gap: 1 }}>
                        {selectedCustomer.verified ? (
                          <Chip 
                            icon={<CheckCircle />} 
                            label="Verified" 
                            color="success" 
                            size="small"
                            variant="outlined"
                          />
                        ) : (
                          <Chip 
                            icon={<Cancel />} 
                            label="Unverified" 
                            color="warning" 
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </Box>
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">
                        Account Actions
                      </Typography>
                      <Box sx={{ mt: 0.5 }}>
                        <Button
                          size="small"
                          onClick={() => handleToggleVerification(selectedCustomer.id, selectedCustomer.verified)}
                          color={selectedCustomer.verified ? "error" : "success"}
                          variant="outlined"
                          sx={{ textTransform: 'none' }}
                          startIcon={selectedCustomer.verified ? <Cancel /> : <CheckCircle />}
                        >
                          {selectedCustomer.verified ? "Revoke Verification" : "Verify User"}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        )}
        
        {/* Address Tab */}
        {tabValue === 1 && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Shipping Address
              </Typography>
              
              <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                {selectedCustomer.street || selectedCustomer.city || selectedCustomer.village || selectedCustomer.country ? (
                  <>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
                      <LocationOn color="action" sx={{ mt: 0.5, mr: 1 }} />
                      <Box>
                        <Typography variant="body1" fontWeight={500}>
                          {selectedCustomer.name || "No Name"}
                        </Typography>
                        
                        {selectedCustomer.street && (
                          <Typography variant="body2" gutterBottom>
                            {selectedCustomer.street}
                          </Typography>
                        )}
                        
                        <Typography variant="body2" gutterBottom>
                          {[
                            selectedCustomer.village,
                            selectedCustomer.city, 
                            selectedCustomer.postalCode
                          ].filter(Boolean).join(', ')}
                        </Typography>
                        
                        {selectedCustomer.country && (
                          <Typography variant="body2">
                            {selectedCustomer.country}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    
                    {selectedCustomer.phone && (
                      <Box sx={{ display: 'flex', alignItems: 'center', ml: 4 }}>
                        <Phone fontSize="small" color="action" sx={{ mr: 1 }} />
                        <Typography variant="body2">
                          {selectedCustomer.phone}
                        </Typography>
                      </Box>
                    )}
                  </>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 3 }}>
                    <LocationOn color="action" sx={{ fontSize: 48, opacity: 0.5, mb: 1 }} />
                    <Typography variant="body1" gutterBottom>
                      No address information available
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      This customer hasn't provided their address yet
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Contact Preferences
              </Typography>
              
              <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={selectedCustomer.emailVisibility}
                      disabled
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="body2" fontWeight={500}>
                        Email Visibility
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {selectedCustomer.emailVisibility 
                          ? "Customer's email is visible to other users" 
                          : "Customer's email is private"}
                      </Typography>
                    </Box>
                  }
                />
                
                <Box sx={{ mt: 3 }}>
                  <Typography variant="subtitle2" fontWeight={500} gutterBottom>
                    Data Privacy
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    This customer's data is protected under privacy laws. Personal information should only be used for account management and order processing.
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={() => setViewDialogOpen(false)} 
          variant="outlined"
          sx={{ textTransform: 'none' }}
        >
          Close
        </Button>
        <Button 
          variant="contained"
          onClick={() => {
            setViewDialogOpen(false);
            handleEditClick({ stopPropagation: () => {} }, selectedCustomer);
          }}
          startIcon={<Edit />}
          sx={{ textTransform: 'none' }}
        >
          Edit Customer
        </Button>
      </DialogActions>
    </>
  )}
</Dialog>

      {/* Edit Customer Dialog */}
      <Dialog
        open={editDialogOpen}
        onClose={() => setEditDialogOpen(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        {selectedCustomer && (
          <>
            <DialogTitle>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" fontWeight={600}>
                  Edit Customer: {selectedCustomer.name || selectedCustomer.username}
                </Typography>
                <IconButton
                  edge="end"
                  onClick={() => setEditDialogOpen(false)}
                >
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            
            <DialogContent dividers>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <Avatar
                      src={getAvatarUrl(selectedCustomer)}
                      sx={{ 
                        width: 120, 
                        height: 120, 
                        mb: 2,
                        mx: 'auto',
                        boxShadow: 3,
                      }}
                    />
                    <Typography variant="body2" color="text.secondary">
                      Account ID: {selectedCustomer.id}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" display="block">
                      Created: {formatDateTime(selectedCustomer.created)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" display="block">
                      Updated: {formatDateTime(selectedCustomer.updated)}
                    </Typography>
                  </Box>
                  
                  <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                    <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                      Account Settings
                    </Typography>
                    
                    <FormControlLabel
                      control={
                        <Switch
                          checked={editForm.verified}
                          onChange={handleInputChange}
                          name="verified"
                          color="primary"
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body2" fontWeight={500}>
                            Verified Account
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Email verification status
                          </Typography>
                        </Box>
                      }
                    />
                    
                    <Divider sx={{ my: 2 }} />
                    
                    <FormControlLabel
                      control={
                        <Switch
                          checked={editForm.emailVisibility}
                          onChange={handleInputChange}
                          name="emailVisibility"
                          color="primary"
                        />
                      }
                      label={
                        <Box>
                          <Typography variant="body2" fontWeight={500}>
                            Email Visibility
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Make email visible to other users
                          </Typography>
                        </Box>
                      }
                    />
                  </Paper>
                </Grid>
                
                <Grid item xs={12} md={8}>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Personal Information
                  </Typography>
                  
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Username"
                        name="username"
                        value={editForm.username}
                        onChange={handleInputChange}
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              @
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Full Name"
                        name="name"
                        value={editForm.name}
                        onChange={handleInputChange}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Email Address"
                        name="email"
                        value={editForm.email}
                        onChange={handleInputChange}
                        variant="outlined"
                        type="email"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Phone Number"
                        name="phone"
                        value={editForm.phone}
                        onChange={handleInputChange}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                  
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Address Information
                  </Typography>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Street Address"
                        name="street"
                        value={editForm.street}
                        onChange={handleInputChange}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="City"
                        name="city"
                        value={editForm.city}
                        onChange={handleInputChange}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Village/District"
                        name="village"
                        value={editForm.village}
                        onChange={handleInputChange}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Country"
                        name="country"
                        value={editForm.country}
                        onChange={handleInputChange}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Postal Code"
                        name="postalCode"
                        value={editForm.postalCode}
                        onChange={handleInputChange}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            
            <DialogActions sx={{ p: 2 }}>
            <Button 
                onClick={() => setEditDialogOpen(false)} 
                variant="outlined"
                sx={{ textTransform: 'none' }}
              >
                Cancel
              </Button>
              <Button 
                variant="contained"
                onClick={handleSubmit}
                startIcon={<SaveAlt />}
                disabled={loading}
                sx={{ textTransform: 'none' }}
              >
                {loading ? "Saving..." : "Save Changes"}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Delete Customer Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle>
          <Typography variant="h6" fontWeight={600}>
            Delete Customer Account
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to delete {selectedCustomer?.name || selectedCustomer?.username || "this customer"}?
          </Typography>
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            This action cannot be undone. All customer data including cart, wishlist and order history will be permanently deleted.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={() => setDeleteDialogOpen(false)} 
            variant="outlined"
            sx={{ textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained"
            color="error"
            onClick={handleDeleteCustomer}
            startIcon={<Delete />}
            disabled={loading}
            sx={{ textTransform: 'none' }}
          >
            {loading ? "Deleting..." : "Delete Customer"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Export Dialog */}
      <Dialog
        open={exportDialogOpen}
        onClose={handleExportDialogClose}
        PaperProps={{
          sx: { borderRadius: 2 }
        }}
      >
        <DialogTitle>
          <Typography variant="h6" fontWeight={600}>
            Export Customers Data
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" gutterBottom>
              Export customers data as CSV format
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Select the customers you want to export or choose to export all customers.
            </Typography>
          </Box>
          
          <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, mb: 3 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectAllCustomers}
                  onChange={toggleSelectAllCustomers}
                  color="primary"
                />
              }
              label={
                <Typography variant="body1" fontWeight={500}>
                  Export all customers ({customers.length})
                </Typography>
              }
            />
            
            {!selectAllCustomers && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Selected customers: {selectedRows.length} of {customers.length}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Select customers from the table to export their data
                </Typography>
              </Box>
            )}
          </Paper>
          
          <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
              Export Information
            </Typography>
            
            <Box sx={{ mt: 1 }}>
              <Typography variant="body2" gutterBottom>
                <strong>Export format:</strong> CSV
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>Current date:</strong> {currentDate}
              </Typography>
              <Typography variant="body2" gutterBottom>
                <strong>Generated by:</strong> {currentUser}
              </Typography>
              <Typography variant="body2">
                <strong>Data fields:</strong> ID, Username, Name, Email, Phone, Address, Country, Verification status, Created date, Updated date, Cart items, Wishlist items
              </Typography>
            </Box>
          </Paper>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button 
            onClick={handleExportDialogClose} 
            variant="outlined"
            sx={{ textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained"
            color="primary"
            onClick={handleExport}
            startIcon={exportLoading ? <CircularProgress size={20} /> : <FileDownload />}
            disabled={exportLoading || (!selectAllCustomers && selectedRows.length === 0)}
            sx={{ textTransform: 'none' }}
          >
            {exportLoading ? "Exporting..." : "Export to CSV"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for alerts */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert 
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} 
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CustomersPage;